import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
    FaBuilding, 
    FaUserTie, 
    FaUsers, 
    FaCalendarAlt, 
    FaBell, 
    FaChartLine, 
    FaClipboardList,
    FaUserPlus,
    FaEye,
    FaArrowRight,
    FaCalendar,
    FaSignInAlt,
    FaKey,
    FaCalendarCheck
} from 'react-icons/fa';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import './ManagerDashboard.css';

const ManagerDashboard = () => {
    const [stats, setStats] = useState({
        totalEmployees: 0,
        totalDepartments: 0,
        maleEmployees: 0,
        femaleEmployees: 0,
        permanentEmployees: 0,
        contractEmployees: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Use base_url from package.json
    const baseUrl = 'https://api.burrayhr.com';

    const [dashboardData, setDashboardData] = useState({
        totalHrManagers: 0,
        totalEmployees: 0,
        recentActivities: [],
        companyInfo: {},
        pendingLeaveRequests: 0,
        approvedLeaveRequests: 0,
        rejectedLeaveRequests: 0,
        loading: true,
        error: null
    });

    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${baseUrl}/api/reports`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                console.log(response)
                
                setDashboardData({
                    totalHrManagers: response.data.total_hr_managers || 0,
                    totalEmployees: response.data.employees?.length || 0,
                    recentActivities: response.data.activities || [],
                    loggedInUser: response.data.logged_in_user,
                    companyInfo: {
                        name: response.data.company.name || "Company Name",
                        status: response.data.company_status || "Active",
                        employeeCount: response.data.employees?.length || 0,
                        departmentCount: response.data.departments?.length || 0
                    },
                    pendingLeaveRequests: response.data.pending_leaves || 0,
                    approvedLeaveRequests: response.data.approved_leaves || 0,
                    rejectedLeaveRequests: response.data.rejected_leaves || 0,
                    loading: false,
                    error: null
                });
                
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                setDashboardData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.response?.data?.message || 'Failed to load dashboard data'
                }));
            }
        };

        fetchDashboardData();
    }, []);

    const getEmployees = async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${baseUrl}/api/employees`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        setEmployees(response.data);
    }

    const employeesCount = employees.length;

    useEffect(() => {
        getEmployees();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const getActivityIcon = (type) => {
        switch(type) {
            case 'employee_create':
                return <FaUserPlus className="activity-icon employee" />;
            case 'employee_delete':
                return <FaUserPlus className="activity-icon employee" />;
            case 'user_login':
                return <FaSignInAlt className="activity-icon hr" />;
            case 'department_delete' || 'department_updated' || 'department_created':
                return <FaBuilding className="activity-icon department" />;
            case 'department_create' || 'department_updated' || 'department_created':
                return <FaBuilding className="activity-icon department" />;
            case 'employee_update':
                return <FaClipboardList className="activity-icon update" />;
            case 'password_change':
                return <FaKey className="activity-icon leave" />;
            case 'leave_approved':
                return <FaCalendarAlt className="activity-icon leave-approved" />;
            case 'leave_rejected':
                return <FaCalendarAlt className="activity-icon leave-rejected" />;
            default:
                return <FaBell className="activity-icon" />;
        }
    };

  return (
        <div className="app-container">
            <Sidebar />
            <div className="main-wrapper">
        <Topbar />
                <div className="content-wrapper">
            <div className="admin-dashboard-container">
                        

                        {dashboardData.loading ? (
                            <div className="loading-spinner">
                                <div className="spinner"></div>
                                <p>Loading dashboard data...</p>
                            </div>
                        ) : dashboardData.error ? (
                            <div className="error-message">
                                <p>{dashboardData.error}</p>
                            </div>
                        ) : (
                            <>
                                {/* Company Overview Card */}
                                <div className="company-overview-card">
                                <div className="dashboard-header" style={{ backgroundColor: '#004080', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                                <div className="welcome-section" style={{ width: '100%' }}>
                                    <h1 style={{ color: '#fff', margin: '0 0 10px 0', fontSize: '24px' }}>Welcome, {dashboardData?.loggedInUser?.first_name} {dashboardData?.loggedInUser?.last_name}</h1>
                                    <p style={{ color: '#e0e0e0', margin: '0 0 10px 0', fontSize: '16px' }}>Here's what's happening in your company today</p>
                                </div>
                            </div>

                            {/* Stats Section with improved styling */}
                            <div className="company-stats" style={{ display: 'flex', gap: '10px', justifyContent: 'space-around', flexWrap: 'wrap' }}>
                                {/* Employee Count Card */}
                                <div className="stat-card" style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center', flex: '1', minWidth: '150px' }}>
                                    <div className="stat-item">
                                        <span className="stat-value" style={{ display: 'block', fontSize: '28px', fontWeight: 'bold', color: '#004080' }}>{dashboardData?.companyInfo?.employeeCount || 0}</span>
                                        <span className="stat-label" style={{ fontSize: '14px', color: '#666' }}>Employees</span>
                                    </div>
                                </div>

                                {/* Department Count Card */}
                                <div className="stat-card" style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textAlign: 'center', flex: '1', minWidth: '150px' }}>
                                    <div className="stat-item">
                                        <span className="stat-value" style={{ display: 'block', fontSize: '28px', fontWeight: 'bold', color: '#004080' }}>{dashboardData?.companyInfo?.departmentCount || 0}</span>
                                        <span className="stat-label" style={{ fontSize: '14px', color: '#666' }}>Departments</span>
                                    </div>
                                </div>

                                {/* Leave Requests Card */}
                                <div className="stat-card leave-requests-card" style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flex: '2', minWidth: '250px' }}>
                                    <h3 style={{ color: '#004080', margin: '0 0 15px 10px', fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                        <FaCalendarCheck className="icon" /> 
                                        <span style={{ marginLeft: '10px' }}>Department Employees</span>
                                    </h3>
                                    <div className="leave-stats" style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>
                                        <div className="leave-stat-item">
                                            <span className="leave-stat-value" style={{ display: 'block', fontSize: '24px', fontWeight: 'bold', color: '#28a745' }}>{employeesCount || 0}</span>
                                        </div>                
                                    </div>
                                </div>
                            </div>
                                </div>

                                {/* Recent Activities */}
                                <div className="recent-activities-section">
                                    <div className="section-header">
                                        <h2>Recent Activities</h2>
                                        <Link to="/manager/activities" className="view-all-link">
                                            View All <FaEye />
                                        </Link>
                                    </div>
                                    <div className="activities-list">
                                        {dashboardData.recentActivities.slice(0, 10).map(activity => (
                                            <div key={activity.id} className="activity-item">
                                                {getActivityIcon(activity.action_type)}
                                                <div className="activity-content">
                                                    <p className="activity-message">{activity.description}</p>
                                                    <span className="activity-time">{formatDate(activity.created_at)}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManagerDashboard;
